import { InputNumber } from 'primereact/inputnumber'

import { cap } from '../../../State'
import { translations } from '../../../translations'

const language = cap.language.state || 'IT'
const t = translations[language] || translations.IT

const GROUP_LABELS = {
  Base: t.mxGruppoBase,
  Corporate: t.mxGruppoCorporate,
  Trattamento: t.mxGruppoTrattamento,
  'Livelli Hotel Program': t.mxGruppoLivelliHotel
}

export const QuotesTypeElement = ({
  coefficient: [coefficient, setCoefficient],
  filter: { name, code }
}) => {
  if (!coefficient || !Array.isArray(coefficient)) return null
  return (
    <div>
      <div className="admin-coefficient-filter-head">
        <div className="admin-coefficient-filter-title">
          {t.mxTipoPreventivo}
          {name}:
        </div>
        <div className="admin-coefficient-filter-sub">
          {t.mxImpostaCoefficientiPer}
          {name}:
        </div>
      </div>
      {Object.keys(coefficient.find((obj) => obj.type === name) || {})?.map((key) => {
        if (key === 'type') return null
        return (
          <div key={key} className="admin-coefficient-coeff-block">
            <div className="admin-coefficient-coeff-group-title">{GROUP_LABELS[key] || key}</div>
            <div className="admin-coefficient-coeff-grid">
              {coefficient
                .find((obj) => obj.type === name)
                [key]?.map((coeff, index) => (
                  <div key={index} className="admin-coefficient-coeff-item">
                    <label>{coeff.name}</label>
                    <div className="n-input-number">
                      <InputNumber
                        className="inputNumbers"
                        placeholder={coeff.name}
                        value={coeff.value}
                        onValueChange={(e) =>
                          setCoefficient((prev) => {
                            const newCoefficient = prev
                            newCoefficient.find((obj) => obj.type === name)[key][index].value =
                              e.value
                            return newCoefficient
                          })
                        }
                        mode="decimal"
                        showButtons
                        min={0}
                        max={50}
                        step={0.01}
                      />
                    </div>
                  </div>
                ))}
            </div>
          </div>
        )
      })}
    </div>
  )
}
